export function getTextColorForBackground(
  hexBackgroundColor = 'FFFFFF',
  lightTextColor = 'FFFFFF',
  darkTextColor = '333333'
) {
  const [r, g, b] = hexColorToRGB(hexBackgroundColor)

  if (colorIsLight(r, g, b)) {
    return darkTextColor
  }
  return lightTextColor
}

/* Perceptive Luminance function. See:
 - http://codepen.io/WebSeed/pen/pvgqEq
 - http://stackoverflow.com/a/1855903/186965 */
function colorIsLight(r, g, b) {
  return (1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255) < 0.5
}

function scrubHexColor(hexString) {
  const hexColorString = (`${hexString}`).replace(/#/, '')
  if (hexColorString.length !== 3 && hexColorString.length !== 6) {
    console.warn(`${hexString} is not a valid hex color value`)
    return '9EDCF7'
  }
  return hexColorString
}

/* Converts a hex color string to a list of RGB color values */
function hexColorToRGB(hexColor) {
  const hexColorString = scrubHexColor(hexColor)

  let r, g, b
  if (hexColorString.length === 3) {
    [r, g, b] = Array.prototype.map.call(hexColorString, (x) => x + x)
  } else {
    r = hexColorString.slice(0, 2)
    g = hexColorString.slice(2, 4)
    b = hexColorString.slice(4, 6)
  }

  return [r, g, b].map((hexValue) => parseInt(hexValue, 16))
}



// WEBPACK FOOTER //
// ./src/scripts/utils/color.js